import React from 'react';
import { Box } from '@mui/material';
import { useRecoilState } from 'recoil';
import Select from 'components/select';
import { OrderPayload } from 'pages/myidm/store';
import { resetCostEstimateDetails } from 'pages/myidm/utils';
import { MODIFY_REQUEST_TYPE, LDAP_GROUP } from 'pages/myidm/utils/constant';

export const ModifyRequestType = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);

    const allOptions = [
        { label: MODIFY_REQUEST_TYPE.MEMBERSHIP, value: MODIFY_REQUEST_TYPE.MEMBERSHIP },
        { label: MODIFY_REQUEST_TYPE.REMOVAL, value: MODIFY_REQUEST_TYPE.REMOVAL },
        // { label: MODIFY_REQUEST_TYPE.GROUP_OWNER_CHANGE, value: MODIFY_REQUEST_TYPE.GROUP_OWNER_CHANGE },
    ];

    const ldapOptions = [{ label: MODIFY_REQUEST_TYPE.MEMBERSHIP, value: MODIFY_REQUEST_TYPE.MEMBERSHIP }];

    // Show only Membership for LDAP Group, all options for AD Group
    const options = order?.groupType === LDAP_GROUP ? ldapOptions : allOptions;

    const handleOnSelectChange = (selected) => {
        const shouldUpdateOrderState = order?.modifyRequestType !== selected.value;
        if (shouldUpdateOrderState) {
            setOrder({
                ...order,
                modifyRequestType: selected.value,
                domainType: null,
                adGroup: null,
                adGroupOwner: null,
                members: [],
                groupOwner: null,
                groupOwnerDetails: null,
                // New - AD Group
                multipleResourceGroups: [
                    {
                        groupCategory: null,
                        groupSubCategory: null,
                        activeDirectoryGroupType: null,
                        domainType: null,
                        groupOwner: null,
                        groupName: null,
                        members: [],
                    },
                ],
                // Modify - AD Group - Membership
                multipleAdGroups: [{ adGroup: null, adGroupOwner: null, members: [] }],
                // Modify - AD Group - Removal
                adGroupMembers: [],
                estimatedCost: resetCostEstimateDetails,
            });
        }
    };

    React.useEffect(() => {
        if (!order?.modifyRequestType && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.modifyRequestType, order?.isTouched]);

    // Reset modifyRequestType if switching to LDAP and current selection is not Membership
    React.useEffect(() => {
        if (order?.groupType === LDAP_GROUP && order?.modifyRequestType && order?.modifyRequestType !== MODIFY_REQUEST_TYPE.MEMBERSHIP) {
            setOrder({
                ...order,
                modifyRequestType: null,
            });
        }
    }, [order?.groupType]);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Select
                dataTestId="modify-request-type-autocomplete"
                key="modifyRequestType"
                label="Modify Request Type *"
                value={options.find((option) => option.value === order?.modifyRequestType)?.label || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isRequired={isTouched}
            />
        </Box>
    );
};

export default React.memo(ModifyRequestType);
